// Utility to clear authentication data and reset session
import { debugAuth } from './debug';

export const clearAuthData = () => {
  try {
    debugAuth('Clearing all authentication data');
    
    // Clear localStorage
    localStorage.removeItem('user');
    
    // Clear sessionStorage
    sessionStorage.clear();
    
    // Clear any cookies related to auth
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    
    debugAuth('Authentication data cleared successfully');
    
    // Reload the page to reset the application state
    window.location.reload();
    
    return true;
  } catch (error) {
    debugAuth('Error clearing auth data:', error);
    return false;
  }
};

export const resetApplication = () => {
  try {
    debugAuth('Resetting application state');
    
    // Clear all storage
    clearAuthData();
    
    // Force redirect to login
    window.location.href = '/login';
    
    return true;
  } catch (error) {
    debugAuth('Error resetting application:', error);
    return false;
  }
};

// Function to check if there are any stuck states
export const checkForStuckState = () => {
  const user = localStorage.getItem('user');
  const hasUser = !!user;
  
  debugAuth('Checking for stuck state', { hasUser });
  
  if (hasUser) {
    try {
      const userData = JSON.parse(user);
      const hasToken = !!userData.token;
      const hasRoles = !!userData.roles && Array.isArray(userData.roles);
      
      debugAuth('User data analysis', { hasToken, hasRoles, roles: userData.roles });
      
      // If user data is incomplete, clear it
      if (!hasToken || !hasRoles) {
        debugAuth('Incomplete user data detected, clearing');
        clearAuthData();
        return true;
      }
    } catch (error) {
      debugAuth('Invalid user data in localStorage, clearing');
      clearAuthData();
      return true;
    }
  }
  
  return false;
}; 